class OwnerObj {

	
	constructor() {
		

	}
	
	
	static getProperty(owner, propertyId){
		if(!Array.isArray(owner.properties) || !owner.properties.length)
			return false;
		
		var idx = owner.properties.findIndex((p)=>{return p.id == propertyId});
		if(idx != -1){
			return owner.properties[idx];
		}
		return false;
	}
	
	
	static changePropertyState(owner, propertyId, newState){
		
		var prop;
		
		if(prop = OwnerObj.getProperty(owner, propertyId)){
			
			prop.status = newState;
			return true;
		}
		return false;
		
		
	}
	static getPropertyState(owner, propertyId){
		var prop;
		
		if(prop = OwnerObj.getProperty(owner, propertyId)){
			return prop.status;
		}
		return '';
	}

}

export default OwnerObj;